export const CONTACT_FORM_TIMEOUT = 15 * 1000; // ms
export const DEMO_FORM_TIMEOUT = 60 * 1000; // ms
// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const RECAPTCHA_SITE_TOKEN = "6Lf8Y7EUAAAAADo57RvuYqxA07ozmYYrnch4Vesy";
